import PropTypes from "prop-types";

import data from "@constants/best-in-travel/2025";
import { BIT_PROP_TYPES } from "@constants/best-in-travel/2025/proptypes";

import BestInTravel from "./index.page";

export default function CategoryPage({
  category,
  destinations,
  inactiveDestinations,
  campaign,
  videos,
  meta,
}) {
  return (
    <BestInTravel
      destinations={destinations}
      inactiveDestinations={inactiveDestinations}
      category={category}
      campaign={campaign}
      videos={videos}
      meta={meta}
    />
  );
}

export async function getServerSideProps({ query }) {
  /**
   * Find and return the category object that matches the queried category name
   */
  const category = data.categories.find(c => c.name === query.category);

  /**
   * If no category matched the query, 404
   */
  if (!category) {
    return { notFound: true };
  }
  const { meta, media } = category;
  /**
   * Collect destinations with the queried category
   */
  const destinations = data.destinations.filter(
    destination => destination.meta.category === query.category
  );

  /**
   * Collect destinations that do not match the queried category
   */
  const inactiveDestinations = data.destinations.filter(
    destination => destination.meta.category !== query.category
  );

  return {
    props: {
      campaign: {
        title: data.title,
        media,
      },
      destinations,
      inactiveDestinations,
      category,
      disableAlert: true,
      meta,
      navbarClassName: "bit-navbar fixed top-0 w-full",
    },
  };
}

CategoryPage.propTypes = {
  category: BIT_PROP_TYPES.category.isRequired,
  destinations: PropTypes.arrayOf(BIT_PROP_TYPES.destination).isRequired,
  inactiveDestinations: PropTypes.arrayOf(BIT_PROP_TYPES.destination)
    .isRequired,
  campaign: PropTypes.shape({
    title: PropTypes.string.isRequired,
    media: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(["video", "image"]).isRequired,
        orientation: PropTypes.oneOf(["portrait", "landscape"]).isRequired,
        src: PropTypes.shape({
          poster: PropTypes.string.isRequired,
          mp4: PropTypes.string.isRequired,
          webm: PropTypes.string.isRequired,
        }).isRequired,
      })
    ).isRequired,
  }).isRequired,
  meta: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    canonicalUrl: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }).isRequired,
};
